
const namespaced = true;

const state = {
  equipment: null,
  clients: [],
  makers: [],
  sites: [],
};

const mutations = {
  SET_EQUIPMENT(state, equipment) {
    state.equipment = equipment;
  },
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_MAKERS(state, makers) {
    state.makers = makers;
  },
};

const actions = {
  async fetchClients({ commit, dispatch, rootState }) {
    commit(`SET_CLIENTS`, []);
    let maker = rootState[`model/client`].company;
    if (!maker.isRoot && !maker.isSelfMaker) {
      maker = rootState[`model/user`].me.client;
    }
    const clients = await dispatch(`model/client/fetchClients`, maker.id, { root: true });

    commit(`SET_CLIENTS`, clients);
    return clients;
  },
  async fetchSites({ commit, dispatch }, clientId) {
    commit(`SET_SITES`, []);
    let sites = [];
    if (clientId) {
      sites = await dispatch(`model/site/fetchSites`, clientId, { root: true });
      commit(`SET_SITES`, sites);
    }

    return sites;
  },
  async fetchMakers({ commit, dispatch }) {
    commit(`SET_MAKERS`, []);
    const makers = await dispatch(`model/maker/fetchMakers`, null, { root: true });

    commit(`SET_MAKERS`, makers);
    return makers;
  },
  async addEquipment({ commit, dispatch }, equipment) {
    const dbEquipment = await dispatch(`model/equipment/addEquipment`, equipment, { root: true });

    commit(`SET_EQUIPMENT`, dbEquipment);

    return dbEquipment;
  },
  async updateEquipment({ dispatch, commit }, equipment) {
    const dbEquipment = await dispatch(`model/equipment/updateEquipment`, equipment, { root: true });

    commit(`SET_EQUIPMENT`, dbEquipment);

    return dbEquipment;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
